import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, XCircle, MapPin } from 'lucide-react';
import { Button } from '../ui/button';

const ResultShell = ({ tone, icon: Icon, children, testId }) => {
  const palette = {
    success: 'bg-green-50 border-green-200 text-green-600',
    info: 'bg-blue-50 border-blue-200 text-blue-600',
    neutral: 'bg-gray-50 border-gray-200 text-gray-500',
    warn: 'bg-amber-50 border-amber-200 text-amber-600',
  }[tone];

  const [shellClass, iconColor] = palette.split(' text-');
  return (
    <div
      className={`flex items-start space-x-3 ${shellClass} border rounded-lg p-4`}
      data-testid={testId}
    >
      <Icon className={`w-5 h-5 text-${iconColor} flex-shrink-0 mt-0.5`} />
      <div className="space-y-3">{children}</div>
    </div>
  );
};

export const InvalidResult = () => (
  <ResultShell tone="warn" icon={XCircle}>
    <p className="text-sm text-gray-700">Please enter a valid 5-digit ZIP code.</p>
  </ResultShell>
);

export const PrimaryResult = ({ zip }) => (
  <ResultShell tone="success" icon={CheckCircle2} testId="availability-result-primary">
    <p className="text-sm text-gray-800">
      <span className="font-semibold">Great news — we serve {zip}!</span> You&apos;re right inside our primary service area.
    </p>
    <Link to="/contact">
      <Button size="sm" className="bg-coral-500 hover:bg-coral-600 text-white">
        Book Your Consultation
      </Button>
    </Link>
  </ResultShell>
);

export const NearbyResult = ({ zip }) => (
  <ResultShell tone="info" icon={CheckCircle2} testId="availability-result-nearby">
    <p className="text-sm text-gray-800">
      <span className="font-semibold">{zip} is just outside our primary area.</span> We often serve nearby ZIP codes with a small added travel cost — reach out and we&apos;ll confirm availability.
    </p>
    <Link to="/contact">
      <Button size="sm" className="bg-coral-500 hover:bg-coral-600 text-white">
        Contact Us
      </Button>
    </Link>
  </ResultShell>
);

export const OutsideResult = ({ zip }) => (
  <ResultShell tone="neutral" icon={MapPin} testId="availability-result-outside">
    <p className="text-sm text-gray-800">
      We don&apos;t currently service {zip} on a regular basis, but we&apos;d still love to hear from you. Contact us to see if we can help or recommend a trusted option nearby.
    </p>
    <Link to="/contact">
      <Button size="sm" variant="outline">
        Get in Touch
      </Button>
    </Link>
  </ResultShell>
);
